export const EmbedDeviceVersion = {
    DESKTOP: {
        '2017': '2017'
    },
    SAMSUNG: {
        '2017': '2017'
    },
    LG: { '3.5': '3.5' },
    COMCAST_FLEX: {
        'Xi6': 'Xi6',
        'Xi5': 'Xi5',
        'XG1v4': 'XG1v4',
        'XG1v3': 'XG1v3',
        'XG2v2 Pace': 'XG2v2 Pace',
        'XiD': 'XiD'
    },
    COMCAST_X1: {
        'Xi6': 'Xi6',
        'Xi5': 'Xi5',
        'XG1v4': 'XG1v4',
        'XG1v3': 'XG1v3',
        'XG2v2 Pace': 'XG2v2 Pace',
        'XiD': 'XiD'
    },
    XBOX: {
        'XBOX One': 'XBOX One',
        'XBOX Series S': 'XBOX Series S',
        'XBOX Series X': 'XBOX Series X'
    },
    PS4: {
        'PS4': 'PS4'
    },
    PS5: {
        'PS5': 'PS5'
    },
    VIZIO: {
        '2017': '2017'
    }
};
